import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Equipment.WashingSieve`]: 'Wash Sieve',
      [`${prefix}.Equipment.GuardSieve`]: 'Guard Sieve',

      [`${prefix}.Masses.InitialDryMass`]: 'Initial Material Dry Mass',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTrays.ContainerLabel`]: 'Tare ID',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTrays.ContainerMass`]: 'Tare Mass',

      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTrays.DateTimePlacedInOvenLocal`]: 'Date and Time in Oven',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTrays.DryMassReadings.DryingTime`]: 'Drying Time',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTrays.ConstantDrySoilMass`]: 'Material Dry Mass',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.DryMassBalance`]: 'Dry Mass Balance',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.Oven`]: 'Oven',

      [`${prefix}.Masses.MeasuredScreeningsConstantDryMass.DryingTrays.DateTimePlacedInOvenLocal`]:
        'Date and Time in Oven',
      [`${prefix}.Masses.MeasuredScreeningsConstantDryMass.DryingTrays.DryMassReadings.DryingTime`]: 'Drying Time',
      [`${prefix}.Masses.MeasuredScreeningsConstantDryMass.Equipment.DryMassBalance`]: 'Dry Mass Balance',

      [`${prefix}.Masses.WashedDryMass`]: 'Portion Washed Dry Mass',
      [`${prefix}.Masses.WashingsDryMass`]: 'Washings',

      [`${prefix}.Results.PercentPassingWashingSieve`]: 'Finer than 63µm by washing',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.PercentPassingWashingSieve`]: '%',
    })
  );

export default getLabelConfig;
